<script>
	import { getContext } from 'svelte';
	import { TABS } from './Tabs.svelte';
	import { fly } from 'svelte/transition';

	const panel = {};
	const { registerPanel, selectedPanel, previousBusy, finished } = getContext(TABS);

	registerPanel(panel);
</script>
{#if ($selectedPanel === panel && !$previousBusy)}
	<div in:fly="{{duration: 500, x: 0, y: 100, opacity: 0.0}}"
		 out:fly="{{duration: 200, x: 0, y: 100, opacity: 0.0}}"
				  on:outroend="{() => finished(false)}"
		 >
		 <slot> </slot>
	</div>
{/if}
<style>

</style>
